import styled from "styled-components";

export const LocationView = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;

  & > a.location-card,
  & > div.location-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
    padding: ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.text.default }11;
    color: ${({ theme }) => theme.colors.text.default };
    text-decoration: none;
  }

  & .location-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.info.default }22;
    color: ${({ theme }) => theme.colors.info.default };
  }

  & .location-info {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    overflow: hidden;
  }

  & .location-info > strong,
  & .location-info > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .location-info > strong {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: 600;
  }

  & .location-info > span {
    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
    color: ${({ theme }) => theme.colors.text.default }CC;
  }
`;
